export default __webpack_public_path__ + "3ace4952edcd03d1ed39abdaf99039d7.png";